
<script>
import http from '@/service/http'
import localforage from 'localforage'
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'Usuarios',
  data () {
    return {
      usuario: {
        nome: '',
        sobrenome: '',
        email: '',
        password: '',
        confirm_password: '',
        imagem: ''
      },
      progress: 0,
      errorFile: false,
      options: {
        url: `${process.env.API_URL}/upload-image-square`,
        uploadMultiple: false,
        acceptedFiles: 'image/*',
        headers: {
          path: 'usuarios',
          width: 200,
          height: 200,
          accept: 'all'
        }
      }
    }
  },
  async mounted () {
    const { data } = await http.get(`/usuarios/usuario`)
    this.usuario = data.usuario
  },
  methods: {
    totalProgress (progress, totalBytes, bytesSent) {
      this.progress = progress
    },
    complete (file, status, xhr) {
      if (file.errorMessage) {
        this.errorFile = true
      } else {
        this.errorFile = false
        file.addAttribute('id', xhr.response.id)
        this.usuario.imagem = xhr.response
        this.progress = 0
      }
    },
    destroyImage () {
      this.$swal({
        title: 'Atenção',
        text: `deseja excluir a imagem?`,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(() => {
        this.usuario.imagem = ''
      })
    },
    validate () {
      this.$validator.validateAll().then(success => {
        if (!success) {
          return false
        } else {
          this.submit()
        }
      })
    },
    async submit () {
      const { data } = await http.put('usuarios/update/perfil', this.usuario)
      if (data != null) {
        localforage.setItem('imagem', this.usuario.imagem)
        window.Materialize.toast('Registro salvo com sucesso!!', 4000)
        this.$router.push({ name: 'dashboard' })
      }
    }
  },
  computed: {
    ...mapState(['loading']),
    ...mapGetters(['nome', 'sobrenome']),
    api_url () {
      return process.env.UPLOADS_URL
    }
  }
}
</script>

<template>
	<div>

    <div class="content">

      <div class="row">
        <div class="col s12 m7">
          <h5>Editar Perfil</h5>
        </div>
      </div>

      <div class="row">
        <div class="col s12">

          <form @submit.prevent="validate">

            <div class="row">

              <div class="col s12 m10 offset-m1">

                <div class="row">

                  <div class="col s12">
                    <h5>{{ nome }} {{ sobrenome }}</h5>
                  </div>

                </div>

                <div class="row">

                  <div class="col s12 m3">

                    <vue-clip :options="options" :on-complete="complete" :on-total-progress="totalProgress">
                      <template slot="clip-uploader-action">
                        <div class="row">
                          <div class="col s12">
                            <div class="dz-message">
                              <div class="card">
                                <span class="card-title">Avatar</span>
                                <div class="center-align" style="height: 100px; width: 100%;">
                                  <img v-if="usuario.imagem" :src="`${api_url}/usuarios/${usuario.imagem}`" style="max-width: 90%; max-height: 80px;">
                                  <div v-else>
                                    <img  src="../../../assets/images/thumbupload.jpg" style="max-width: 90%; max-height: 50px;">
                                    <br clear="all" />
                                    <small class="center-align">clique para inserir uma imagem</small>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="progress">
                              <div class="determinate" :style="`width: ${progress}%`"></div>
                            </div>
                            <div v-if="errorFile" class="center-align">Tipo de arquivo inválido</div>
                            <div v-if="usuario.imagem" class="center-align"><i class="material-icons pointer" @click.prevent="destroyImage()">delete_forever</i></div>
                          </div> 
                        </div>
                      </template>
                    </vue-clip>

                  </div>

                  <div class="input-field col s12 m4">
                    <input name="password" id="password" type="password" v-model="usuario.password">
                    <label for="password">Senha</label>
                    <small class="red-text">{{ errors.first('password') }}</small>
                  </div>

                  <div class="input-field col s12 m4">
                    <input name="confirm_password" id="confirm_password" type="password" v-validate data-vv-rules="confirmed:password" :class="{invalid: errors.has('confirm_password')}" v-model="usuario.confirm_password">
                    <label for="confirm_password">Confirmar senha</label>
                    <small class="red-text">{{ errors.first('confirm_password') }}</small>
                  </div>

                </div>

                <div class="row">

                  <div class="input-field col s12">
                    <button class="waves-effect waves-light btn" :disabled="loading">Salvar</button>
                  </div>

                </div>

              </div>

            </div>

          </form>

        </div>
      </div>

    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/features/usuarios/usuarios/perfil.vue